var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { PNL_EMPTY_VALIDATION, PNL_ERROR, PNL_HIDE_EMPTY_VALIDATION, PNL_HIDE_ERROR, PNL_REPORT, PNL_SHOW_SHIMMER, PNL_STOCK_DETAILS, PNL_STREAM_TOGGLE, PROD_ASSET_FILTER_VAL, } from "../../interfaces/Reports/iPNLReport";
var initState = {
    data: {
        PnLData: {
            pnLSummary: {
                totalPnl: "0",
                totalPnlChangePercent: "0",
                realisedPnl: "0",
                realisedPnlChangePercent: "0",
                unrealisedPnl: "0",
                unrealisedPnlChangePercent: "0",
                closePriceDate: "",
                totalMarketValue: "",
                totalClosingCostValue: "",
                totalSellCostValue: "",
                editableCount: 0,
                totalInvestment: "0",
                totalSellValue: "0",
                daysPnLChange: "0",
            },
            pnLDetails: [],
        },
        SearchData: "",
        FilterData: null,
        SortData: [],
        IsSummarize: false,
    },
    selectedStockDetails: {
        tradeDetails: null,
        transactionType: null,
        assetType: null,
        fromDate: "",
        toDate: "",
    },
    downloadStatus: {
        error: null,
        isOpen: null,
    },
    emailStatus: {
        error: null,
        isOpen: null,
    },
    errorData: {
        error: null,
        isOpen: false,
    },
    emptyValidation: {
        icon: null,
        message: null,
    },
    showShimmer: false,
    prodDropDown: null,
    stream: false,
};
var pnlReport = function (state, action) {
    var _a, _b;
    if (state === void 0) { state = initState; }
    switch (action.type) {
        case PNL_REPORT:
            return __assign(__assign({}, state), { data: action.payload.data });
        case PNL_STOCK_DETAILS:
            return __assign(__assign({}, state), { selectedStockDetails: action.payload.selectedStockDetails });
        case PNL_ERROR:
            return __assign(__assign({}, state), (_a = {}, _a[action.errorType] = action.payload.errorData, _a));
        case PNL_HIDE_ERROR:
            return __assign(__assign({}, state), (_b = {}, _b[action.errorType] = initState[action.errorType], _b));
        case PNL_EMPTY_VALIDATION:
            return __assign(__assign({}, state), { emptyValidation: action.payload.emptyValidation });
        case PNL_HIDE_EMPTY_VALIDATION:
            return __assign(__assign({}, state), { emptyValidation: __assign({}, initState.emptyValidation) });
        case PNL_SHOW_SHIMMER:
            return __assign(__assign({}, state), { showShimmer: action.payload.showShimmer });
        case PROD_ASSET_FILTER_VAL:
            return __assign(__assign({}, state), { prodDropDown: action.payload.prodDropDown });
        case PNL_STREAM_TOGGLE:
            return __assign(__assign({}, state), { stream: action.payload.stream });
        default:
            return __assign({}, state);
    }
};
export default pnlReport;
